import React from 'react'

function AdminSystem() {
  return (
      <>
          <head>
              <title>نظام إداري</title>
              <meta name="description" content="عنوان: نظام إداري متكامل.. كل شيء تحت السيطرة!" />
          </head>
          <div>
              <h1>نظام إداري</h1>
              <p>لإدارة مؤسستك بكفاءة، نقدم نظامًا إداريًا يشمل:</p>
              <ol>
                  <li> إدارة المشاريع والمهام.</li>
                  <li> تتبع المستودعات والمخزون.</li>
                  <li> توثيق العقود والمراسلات.</li>
              </ol>
              <p>📂 كل الأدوات الإدارية في مكان واحد!</p>
          </div>
      </>
  )
}

export default AdminSystem